import insightsLight from "../../../../assets/images/insightsLight.png";
import issueGears from "../../../../assets/images/issueGears.png";
import winCup from "../../../../assets/images/winCup.png";
import { Box, Stack, Typography } from "@mui/material";

export type IPerformanceCardState = "WIN" | "ISSUE" | "INSIGHTS";

export type PerformanceReviewCardProps = {
  cardType: IPerformanceCardState;
  bulletPoints?: { header?: string; content: string }[];
};

const cardType2Image: Record<IPerformanceCardState, string> = {
  INSIGHTS: insightsLight,
  ISSUE: issueGears,
  WIN: winCup,
};

const cardType2Title: Record<IPerformanceCardState, string> = {
  WIN: "Win spotlight",
  ISSUE: "Issue spotlight",
  INSIGHTS: "Bo's insights",
};

const cardType2BackgroundColor: Record<IPerformanceCardState, string> = {
  WIN: "var(--success-green-10)",
  ISSUE: "var(--gold-10)",
  INSIGHTS: "var(--sapphire-05)",
};

const cardType2BackgroundAltColor: Record<IPerformanceCardState, string> = {
  WIN: "var(--team-app-win-bg)",
  ISSUE: "var(--team-app-issue-bg)",
  INSIGHTS: "var(--team-app-insights-bg)",
};

export const PerformanceReviewCard = (props: PerformanceReviewCardProps) => {
  return (
    <Box
      display="flex"
      flexDirection={{
        xs: "column",
        sm: "row",
      }}
      gap="1.5rem"
      padding="1.5rem"
      alignItems={{
        xs: "flex-start",
        sm: "center",
      }}
      borderRadius="1rem"
      sx={{
        background: `repeating-linear-gradient(-45deg,  ${
          cardType2BackgroundColor[props.cardType]
        } 0px 5px, ${cardType2BackgroundAltColor[props.cardType]}  5px 6px)`,
      }}
    >
      <Box component="img" src={cardType2Image[props.cardType]} />
      <Stack direction="column" alignSelf="stretch">
        <Typography
          variant="cardTitle"
          sx={{
            fontWeight: 700,
          }}
        >
          {cardType2Title[props.cardType]}
        </Typography>
        <Stack
          alignSelf="stretch"
          alignItems="flex-start"
          justifySelf="stretch"
        >
          <Box component="ul" paddingLeft="1rem">
            {props.bulletPoints?.map((node) => {
              if (node.header) {
                return (
                  <Box key={node.header} component="li">
                    <Typography variant="tableCellBold">
                      {node.header}:{" "}
                    </Typography>
                    <Typography variant="tableCellRegular">
                      {node.content}
                    </Typography>
                  </Box>
                );
              }
              return (
                <Box key={node.content} marginLeft="-1rem">
                  <Typography variant="tableCellRegular">
                    {node.content}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
